<template>
    <div>
        <Title :title="'建议反馈'" :noBorder="true"></Title>
        <Card :padding="20" style="margin: 20px">
            <Form :model="formItem" :label-width="80">
                <FormItem label="标题">
                    <Input v-model="formItem.title"
                           placeholder="问题标题，不超过20个文字"
                           maxlength="20"
                           style="width: 400px"
                    ></Input>
                </FormItem>
                <FormItem label="文字内容">
                    <Input v-model="formItem.textarea"
                           type="textarea"
                           :autosize="{minRows: 6,maxRows: 5}"
                           placeholder="请描述您遇到的问题不超过1000字"
                           maxlength="1000"
                           style="width: 400px"
                    ></Input>
                </FormItem>
                <FormItem label="图片">
                    <Upload action="//jsonplaceholder.typicode.com/posts/">
                        <Button icon="ios-cloud-upload-outline">上传</Button>
                    </Upload>
                </FormItem>
                <FormItem >
                    <Button type="primary" >提交反馈</Button>
                </FormItem>
            </Form>
        </Card>
    </div>
</template>

<script>
    import Title from "../../ability/components/title";
    export default {
        name: "feedback",
        components: {
            Title,
        },
        data(){
            return{
                formItem:{
                    title:'',
                    textarea:''
                }
            }
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>